import React from "react";

const Container = ({ props, children }) => {
  return <div {...props}>{children}</div>;
};

export default Container;
